(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["daastan-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('daastan-visual-slider')) {
  customElements.define('daastan-visual-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.index = 0;
      this.paused = false;
      this.hovered = false;
      this.focused = false;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.dots.forEach(dot => dot.addEventListener('click', () => { this.show(Number(dot.dataset.index)); this.start(); }, { signal }));
      this.querySelector('[data-pause]')?.addEventListener('click', () => { this.paused = !this.paused; this.updatePause(); this.start(); }, { signal });
      this.addEventListener('mouseenter', () => { this.hovered = true; this.start(); }, { signal });
      this.addEventListener('mouseleave', () => { this.hovered = false; this.start(); }, { signal });
      this.addEventListener('focusin', () => { this.focused = true; this.start(); }, { signal });
      this.addEventListener('focusout', () => { queueMicrotask(() => { if (!this.isConnected) return; this.focused = this.contains(document.activeElement); this.start(); }); }, { signal });
      document.addEventListener('visibilitychange', () => this.start(), { signal });
      document.addEventListener('shopify:block:select', (event) => {
        const slide = this.slides.findIndex(item => item.dataset.shopifyEditorBlock?.includes(event.detail.blockId));
        if (slide >= 0) { this.paused = true; this.show(slide); this.updatePause(); this.start(); }
      }, { signal });
      this.motion.addEventListener('change', event => { if (event.matches) this.paused = true; this.updatePause(); this.start(); }, { signal });
      this.setAttribute('data-ready', '');
      this.show(0);
      this.updatePause();
      this.start();
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      const start = Math.min(Math.max(this.index - 2, 0), Math.max(this.slides.length - this.dots.length, 0));
      this.dots.forEach((dot, position) => {
        const target = start + position;
        dot.hidden = target >= this.slides.length;
        dot.dataset.index = String(target);
        dot.setAttribute('aria-current', String(target === this.index));
        const link = this.slides[target]?.querySelector('.daastan-visual-slider__image-link');
        if (link) dot.setAttribute('aria-label', link.getAttribute('aria-label'));
      });
    }
    updatePause() {
      const button = this.querySelector('[data-pause]');
      if (!button) return;
      button.setAttribute('aria-pressed', String(this.paused));
      button.setAttribute('aria-label', this.paused ? this.dataset.play : this.dataset.pause);
      button.querySelector('[data-pause-icon]').textContent = this.paused ? '▷' : 'Ⅱ';
    }
    start() {
      clearInterval(this.timer);
      if (this.paused || this.hovered || this.focused || document.hidden || this.slides.length < 2) return;
      this.timer = setInterval(() => this.show(this.index + 1), Number(this.dataset.interval) || 5000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
